import React from "react";
import { Button } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const OutlinedButtonDisabled = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Outlined Disabled button"}
        value={'<Button variant={"outlined"} disabled>Disabled</Button>'}
      >
        <Button variant={"outlined"} disabled>
          Disabled
        </Button>
      </PreviewAndEditor>
    </>
  );
};

export default OutlinedButtonDisabled;
